import ContentDetailPageHeader from "../components/common/content/content-detail-page-header";
import ContentHeader from "../components/common/content/content-header";
import { StyledContainer } from "../components/common/content/styles";
import { Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
import { ResourcesPage } from "../sanity/types";
import { getResourcesPage } from "../sanity/queries";
import { fallbackResourcesPage } from "../sanity/fallbacks";
import { urlFor } from "../sanity/image";
import {Seo} from "../seo/Seo";
import {AlertToast} from "../components/common/alert-toast";

export default function Resources() {
  const [resourcesPage, setResourcesPage] =
    useState<ResourcesPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let isMounted = true;
    getResourcesPage()
      .then((data: ResourcesPage | null) => {
        if (!isMounted) {
          return;
        }
        if (!data) {
          setResourcesPage(fallbackResourcesPage);
          return;
        }
        setResourcesPage({
          ...fallbackResourcesPage,
          ...data,
        });
      })
      .catch(() => {
        if (isMounted) {
          setResourcesPage(fallbackResourcesPage);
          setErrorMessage("Unable to load resources. Showing fallback content.");
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const imageUrl = resourcesPage?.image
    ? urlFor(resourcesPage.image).width(1600).url()
    : resourcesPage?.imageUrl
    ? process.env.PUBLIC_URL + resourcesPage.imageUrl
    : "";

  return (
    <>
      <Seo
        title={resourcesPage?.metaTitle || resourcesPage?.title}
        description={
          resourcesPage?.metaDescription ||
          "Coptic hymns, audio, and learning resources from St. George Coptic Orthodox Church."
        }
        path="/resources"
        image={imageUrl}
      />
      <StyledContainer maxWidth={false}>
        <ContentDetailPageHeader />
        <AlertToast
          open={!!errorMessage}
          message={errorMessage}
          onClose={() => setErrorMessage("")}
          severity="warning"
        />
        {loading ? (
          <>
            <Skeleton variant="text" width="40%" height={38} sx={{mx: "auto", my: 2}} />
            <Skeleton variant="rectangular" width="100%" height={320} />
          </>
        ) : (
          <>
            <ContentHeader title={resourcesPage?.title || "Coptic Hymns"} />
            {imageUrl && (
              <img
                width="100%"
                src={imageUrl}
                loading="lazy"
                alt={
                  resourcesPage?.imageAlt ||
                  resourcesPage?.image?.alt ||
                  "Coptic Hymns"
                }
              />
            )}
          </>
        )}
      </StyledContainer>
    </>
  );
}
